import { categories } from '@/mocks/home';

export default function Categories() {
  return (
    <section id="categories" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="mb-8 md:mb-10">
        <span className="text-xs font-label text-secondary-600 tracking-[0.2em]">QUICK ENTRY</span>
        <h2 className="mt-2 font-heading font-bold text-foreground-950 text-2xl md:text-3xl tracking-tight">
          按内容形态快速进入
        </h2>
        <p className="mt-2 text-sm font-label text-foreground-600 max-w-xl leading-relaxed">
          同一段语音，形态不同听感也不同。想听什么，直接从这里落地。
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {categories.map((cat) => (
          <a
            key={cat.id}
            href="#hot"
            className="group flex items-center gap-3 p-3.5 rounded-lg bg-background-50 border border-background-200 hover:border-secondary-300 transition-colors cursor-pointer"
          >
            <span className="w-10 h-10 shrink-0 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center group-hover:bg-secondary-500 group-hover:text-background-50 transition-colors">
              <i className={`${cat.icon} text-lg`}></i>
            </span>
            <span className="flex flex-col min-w-0">
              <span className="text-sm font-label text-foreground-900 truncate">{cat.name}</span>
              <span className="text-[11px] font-label text-foreground-500">{cat.count}</span>
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}